import { z } from 'zod';
import { USER_ROLES } from '../constants/index.js';
import { uuidSchema } from './common.js';
export const loginSchema = z.object({
    username: z.string().trim().min(3).max(64),
    password: z.string().min(8).max(128),
});
export const refreshSchema = z.object({
    refreshToken: z.string().min(20),
});
export const authTokensSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    /** Access token lifetime in seconds. */
    expiresIn: z.number().int().positive(),
});
export const currentUserSchema = z.object({
    id: uuidSchema,
    username: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    role: z.enum(USER_ROLES),
});
export const loginResponseSchema = authTokensSchema.extend({
    user: currentUserSchema,
});
//# sourceMappingURL=auth.js.map